import HealthServiceModuleDashboard from "@/components/HealthServiceModuleDashboard";

/* Compatibilidade textual com a regressão dos módulos adicionais do portal:
Módulo navegável · fase 2
*/

export default function ApsFisicaPage() {
  return (
    <HealthServiceModuleDashboard
      title="APS Física"
      eyebrow="Atenção presencial e coordenação territorial do cuidado"
      badgeLabel="Dashboard de homologação ativo"
      serviceKey="aps_fisica"
      accentColor="#f97316"
      gradientClassName="bg-[radial-gradient(circle_at_bottom_left,_rgba(249,115,22,0.22),_transparent_36%),linear-gradient(135deg,#fffaf5_0%,#fff2e8_44%,#ffffff_100%)]"
      description="A APS Física passa a mostrar, em uma visão única, o comportamento do atendimento presencial, a capacidade de retenção da jornada, os encaminhamentos mais relevantes e os sinais populacionais que pedem ação mais próxima do território."
      focusTitle="O que observar neste módulo"
      focusItems={[
        {
          title: "Volume presencial e ritmo operacional",
          description: "O painel ajuda a entender como o fluxo assistencial cresce, estabiliza ou perde tração dentro da atenção primária física.",
        },
        {
          title: "Encaminhamentos e continuidade",
          description: "A comparação por especialidade evidencia onde a APS está resolvendo bem e onde ainda depende de encaminhamento para seguir a jornada.",
        },
        {
          title: "Risco populacional e retenção",
          description: "A leitura de risco apoia a priorização de casos que precisam de cuidado mais ativo, preservando vínculo e acompanhamento contínuo.",
        },
      ]}
    />
  );
}
